import React, { Component } from 'react';
import BaseModal from './BaseModal';

import './styles.scss'
import HelperSystem from '../../helpers/HelperSystem';

interface IModalState {
    show: boolean;
    title?: string | null;
    showConfirm: boolean;
    showCancel: boolean;
    body?: any;
    callBack: any;
    modalProps: any;
    class: string;
    cancelText?: string | null;
    confirmText?: string | null;
}

interface IShow {
    title?: string;
    body?: any | null;
    showConfirm?: boolean;
    show?: boolean;
    showCancel?: boolean;
    callBack?: any;
    modalProps?: any;
    className?: string;
    onCancelText?: string | null;
    confirmText?: string | null;
    cancelText?: string | null;
}

class Modal extends Component<{}, IModalState> {
    private static instance: Modal;

    constructor(props: any) {
        super(props);
        Modal.instance = this;
        this.state = {
            show: false,
            title: null,
            body: null,
            showConfirm: true,
            showCancel: false,
            callBack: null,
            modalProps: null,
            class: ''
        }
    }

    render() {
        return (
            <BaseModal
                show={this.state.show}
                title={this.state.title}
                onConfirm={(this.state.showConfirm ? Modal.onConfirm : null)}
                onCancel={(this.state.showCancel ? Modal.onCancel : null)}
                onConfirmText={((this.state?.confirmText) ? this.state.confirmText : 'OK')}
                onCancelText={((this.state?.cancelText) ? this.state.cancelText : 'Fechar')}
                onHide={(this.state.showCancel ? Modal.onCancel : Modal.onCancel)}
                class={this.state.class}
                {...this.state?.modalProps}>
                {this.state.body}
            </BaseModal>);
    }

    static getErrorMessageText(error: any) { 
        // Verifica se response.data existe e pode ser convertido para string com conteúdo
        if (error.response?.data && String(error.response.data).trim()) {
            if(error.response?.data?.errors){
                if(Array.isArray(error.response?.data?.errors) && (error.response?.data?.errors?.length??0) > 0){
                    if((error.response?.data?.errors?.length??0) >= 3 ){
                        const filteredErrors = error.response?.data?.errors?.filter((msg:any) =>
                            !msg.includes("Error getting value from") &&
                            !msg.includes("One or more errors occurred")
                        );
                        return String(filteredErrors[0]);
                    }else{
                        return String(error.response?.data?.errors[0]);
                    }
                }
                const firstErrorKey = Object.keys(error.response?.data?.errors)[0];
                const firstErrorMessage = error.response?.data?.errors[firstErrorKey]?.[0];
                
                if(firstErrorMessage && Array.isArray(firstErrorMessage) && firstErrorMessage.length > 0 ){
                    return String(firstErrorMessage[0]);
                }
                if(firstErrorMessage){
                    return String(firstErrorMessage);
                }
                return String(error.response?.data?.errors[0]);
            }
            return String(error.response.data);
        }
        // Verifica se existe response.data e se tem conteúdo
        if (error.response?.data?.message && String(error.response.data.message).trim()) {
            return String(error.response.data.message);
        }
        // Verifica a mensagem padrão do erro
        if (error.message && String(error.message).trim()) {
            // if(error.message.includes("Network")){
            //     return `Ops, tivemos um problema para conectar a rede, por favor tente novamente! ${error?.response?.status??""}`;
            // }else
                return String(error.message);
        }

        return "Erro desconhecido ao enviar proposta";
    }

    static getErrorMessage(error: any, payload:any) {
        const msgErro = this.getErrorMessageText(error);
        //Envia erro para o Log de Erros do Front:
        HelperSystem.SaveErrorFront(error,msgErro,payload);
        
        return msgErro;
    };

    static show({ title, body, showConfirm = true, show=true, showCancel = false, callBack = null, modalProps = null, className = '',onCancelText= null, confirmText=null,cancelText=null  }: IShow) {
        Modal.instance.__show({ title, body, showConfirm, show, showCancel, callBack, modalProps, className,onCancelText, confirmText, cancelText});
    }

    static question({ title, body, callBack }: IShow) {
        Modal.instance.__show({ title, body, showConfirm: true, showCancel: true, callBack });
    }

    static onConfirm(params: any = null) {
        Modal.instance.__onConfirm(params);
    }

    static onCancel() {
        Modal.instance.__onCancel();
    }

    __show({ title, body, showConfirm = false, show=true, showCancel = true, callBack, modalProps, className = '',onCancelText, confirmText, cancelText }: IShow) {
        this.setState({ title, body, show: show, showConfirm, showCancel, callBack, modalProps, class: className, confirmText: confirmText, cancelText: cancelText });
    }
    __onConfirm(params: any) {
        this.state.callBack && this.state.callBack(params);
        this.setState({ title: '', body: null, show: false, showConfirm: false, showCancel: false });
    }
    __onCancel() {
        this.setState({ title: '', body: null, show: false, showConfirm: false, showCancel: false });
    }

}

export default Modal;